import { useEffect, useState, useRef } from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

// Анимация счётчика
function useCountUp(target, duration = 900) {
  const [val, setVal] = useState(0);
  const raf = useRef();
  useEffect(() => {
    if (target == null || isNaN(target)) return;
    const start = performance.now();
    const animate = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round((target * eased) * 10) / 10);
      if (p < 1) raf.current = requestAnimationFrame(animate);
    };
    raf.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf.current);
  }, [target]);
  return val;
}

const STATUS_CONFIG = {
  positive: { bg: 'bg-green-50 dark:bg-green-900/20', text: 'text-green-700 dark:text-green-400', icon: TrendingDown, border: 'border-green-200 dark:border-green-800' },
  negative: { bg: 'bg-red-50 dark:bg-red-900/20',    text: 'text-red-600 dark:text-red-400',     icon: TrendingUp,   border: 'border-red-200 dark:border-red-800' },
  neutral:  { bg: 'bg-amber-50 dark:bg-amber-900/20', text: 'text-amber-700 dark:text-amber-400', icon: Minus,        border: 'border-amber-200 dark:border-amber-800' },
};

export default function StatCard({ label, value, unit = 'см', delta, status, highlight }) {
  const animated = useCountUp(value);
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.neutral;
  const Icon = cfg.icon;

  return (
    <div className={`card p-4 hover-lift ${highlight ? 'border-fuchsia/40 dark:border-fuchsia/30' : ''}`}>
      <p className="text-xs font-semibold uppercase tracking-wider text-ink-light-muted dark:text-ink-muted mb-2">
        {label}
      </p>
      <div className="flex items-baseline gap-1">
        <span className="font-display text-2xl font-extrabold text-ink-light dark:text-ink-dark tabular-nums">
          {value != null ? animated : '—'}
        </span>
        {value != null && <span className="text-sm text-ink-light-muted dark:text-ink-muted">{unit}</span>}
      </div>
      {delta != null && (
        <div className={`flex items-center gap-1 mt-2 px-2 py-0.5 rounded-lg w-fit text-xs font-semibold border ${cfg.bg} ${cfg.text} ${cfg.border}`}>
          <Icon size={11} />
          {delta > 0 ? '+' : ''}{delta} {unit}
        </div>
      )}
    </div>
  );
}
